module.exports = __webpack_public_path__ + "imgs/delete-hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/delete-hover.png
// module id = 225
// module chunks = 93